<template>
  <v-container>
    <v-text-field
      prefix="Nombre:"
      class="ml-3 mr-3"
      v-model="selectedItem.settings.component_name"
      single-line
      clearable
      @click="updateEditing(true)"
    />
    <p class="text-h6">Variables bomba</p>
    <v-text-field
      prefix="Motor:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_continuous_running"
      single-line
      clearable
      @click="updateEditing(true)"
    />
    <v-text-field
      prefix="Alarma:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_failure_alarm"
      single-line
      clearable
      @click="updateEditing(true)"
    />
    <v-text-field
      prefix="Orden marcha:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.variable_run_order"
      single-line
      clearable
      @click="updateEditing(true)"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "QLVNBombProperties",

  data() {
    return {};
  },
  computed: {
    ...mapState(["selectedItem"]),
    ...mapState("nodered", ["client"]),
  },

  methods: {
    ...mapActions(["updateEditing"]),
  },

  created() {},
};
</script>

<style></style>
